import React from 'react';
import { Link } from 'react-router-dom';

import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.jsx';
import { connect } from 'react-redux';
import { getClients, removeClient } from '../../redux/actions/clientAction';
import { reset } from '../../redux/actions/searchAction';
import Global from '../../global';
import { permissions } from '../../helpers/utils';
import LoadBar from '../../components/shared/loadBar';

const ActionButton = props => (
  <UncontrolledDropdown>
    <DropdownToggle>...</DropdownToggle>
    <DropdownMenu>
      {
        permissions(props.userLogged, 'estimates', 'create', 0) ?
          <DropdownItem
            to={`/admin/clients/estimatecreate/${props._id}`}
            tag={Link}
          >
            Create Estimate
          </DropdownItem>
          : null
      }
      {
        permissions(props.userLogged, 'clients', 'update', 0) ?
          <DropdownItem to={`/admin/clients/update/${props._id}`} tag={Link}>
            Update
          </DropdownItem>
          : 
          <DropdownItem disabled to={`/admin/clients/update/${props._id}`} tag={Link}>
            Update
          </DropdownItem>
      }
      {
        permissions(props.userLogged, 'clients', 'delete', 4) ?
          <DropdownItem
            onClick={() => {
              props.removeClient(props._id);
              alert('Client Delete');
            }}
          >
            <span className="text-danger">Delete</span>
          </DropdownItem>
          : 
          <DropdownItem disabled to="/" tag={Link}>
            Delete
          </DropdownItem>
      }
    </DropdownMenu>
  </UncontrolledDropdown>
);

class Clients extends React.Component {
  state = {
    modal: false,
    client: {},
  };

  updateWindowDimensions = () => {
    this.setState(prevState => ({
      ...prevState,
      isMobileVersion: window.innerWidth < 1024,
    }));
  };

  async componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    await this.props.getClients();

  }

  async componentDidMount() {
    if (!this.props.userLogged) return this.props.history.push('/auth/login');
    await this.props.reset();
    if (localStorage.getItem('version') !== Global.version) {
      await this.props.logoutUser();
      return this.props.history.push('/auth/login');
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    await this.props.getClients();
  }

  openModal = id => {
    const client = this.props.clients.filter(client => client._id === id)[0];
    this.setState(prevState => ({
      modal: true,
      client,
    }));
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !this.state.modal,
    }));
  };

  searchFunction = () => {
    var input, filter, table, tr, i;
    input = document.getElementById("clientSearchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("clientTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      const tableData = tr[i].getElementsByTagName("td");
      let allTextContent = '';
      for (let ind = 0; ind < tableData.length; ind++) {
          allTextContent += tableData[ind].innerText;
      }
      
      if (allTextContent) {
        if (allTextContent.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }       
    }
  }

  render() {
    const { clients, userLogged } = this.props;
    if (!this.state) return <LoadBar />;
    let clientsFilter = clients;

    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                <Row>
                  <div className="col">
                      {/* <FormGroup className="mb-0"> */}
                        <InputGroup className="input-group-alternative search-margin">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fas fa-search" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            className='search-style'
                            placeholder="Search"
                            type="text"
                            id="clientSearchInput"
                            onChange={this.searchFunction}
                          />
                        </InputGroup>
                      {/* </FormGroup> */}
                    </div>
                    <div className="col text-right">
                      {
                        permissions(userLogged, 'clients', 'create', 0) ?
                        <Button color="primary" type="button" onClick={() => window.location.href = 'addclient'}>
                          Create Client
                        </Button>
                          : null
                      }
                    </div>
                  </Row>
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Information</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" id="clientTable" responsive>
                  <thead className="thead-light">
                    <tr>
                      {!this.state.isMobileVersion ? (
                        <>
                          <th scope="col"></th>
                          <th scope="col">Name</th>
                          <th scope="col">Email</th>
                          <th scope="col">Phone Number</th>
                        </>
                      ) : (
                        <>
                          <th>Details</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {clientsFilter.length === 0 ? (
                      <tbody>
                        <tr>
                          <td>No clients register</td>
                        </tr>
                      </tbody>
                    ) : (
                      clientsFilter.map((e, i) => (
                        <tr key={i} className="details-row">
                          {!this.state.isMobileVersion ? (
                            <>
                              <td>
                                <ActionButton
                                  {...e}
                                  removeClient={this.props.removeClient}
                                  userLogged={userLogged}
                                ></ActionButton>
                              </td>
                              <td onClick={() => this.openModal(e._id)}>
                                {e.firstName} {e.lastName}
                              </td>
                              <td onClick={() => this.openModal(e._id)}>
                                {e.email}
                              </td>
                              <td onClick={() => this.openModal(e._id)}>
                                {e.phone}
                              </td>
                            </>
                          ) : (
                            <>
                              <td>
                                {e.firstName} {e.lastName}
                                <br />
                                <small>
                                  {e.email} {!e.phone ? '' : ` - ${e.phone}`}
                                </small>
                                <div className="buttonfloat-right buttonfloat-right-clients">
                                  <ActionButton
                                    {...e}
                                    removeClient={this.props.removeClient}
                                    userLogged={userLogged}
                                  ></ActionButton>
                                </div>
                              </td>
                            </>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal} size={'lg'}>
          <ModalHeader toggle={this.toggleModal}> Client details </ModalHeader>
          <ModalBody>
            Name:{' '}
            <b>
              {this.state.client.firstName} {this.state.client.lastName}{' '}
              <small>({this.state.client.email})</small>
            </b>
            <br />
            Billing Address: <b>{this.state.client.address}</b> <br />
            Contact Name: <b>{this.state.client.contact}</b> <br />
            Phone: <b>{this.state.client.phone}</b> <br />
            Mobile: <b>{this.state.client.mobile}</b> <br />
            Website: <b>{this.state.client.website}</b> <br />
            Tax Number: <b>{this.state.client.tax}</b> <br />
            Custom Payment Terms: <b>{this.state.client.customPayment}</b>
            <br />
            Notes: <b>{this.state.client.notes}</b>
            <br />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.client.clients,
  userLogged: state.auth.userLogged,
  // search: state.search.search,
});

export default connect(mapStateToProps, { getClients, removeClient, reset })(
  Clients
);
